/**
 * Book a Discovery Call Page
 *
 * Uses a Typeform-style wizard to collect lead information
 * before redirecting to Calendly for booking.
 *
 * This page is accessible without authentication at /book.
 */

import { IntakeWizard } from '@/components/intake'
import { useSEO } from '@/hooks/useSEO'
import { generateBreadcrumbs, breadcrumbLabels } from '@/components/Breadcrumbs'

export default function BookPage() {
  const breadcrumbs = generateBreadcrumbs('/book', breadcrumbLabels)

  useSEO({
    title: 'Book a Discovery Call',
    description:
      "Schedule a free 30-minute discovery call to discuss how Fugue Lab can help your music organization thrive online. Fill out our intake form and we'll connect.",
    url: '/book',
    canonical: '/book',
    breadcrumbs,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'ContactPage',
      name: 'Book a Discovery Call with Fugue Lab',
      description: "Schedule a free consultation to discuss your music organization's digital needs.",
      mainEntity: {
        '@type': 'Organization',
        name: 'Fugue Lab',
        email: 'hello@fuguelab.com',
        url: 'https://fuguelab.com',
      },
    },
  })

  return <IntakeWizard />
}
